/**
 * Created by lucienyan on 2017/12/26.
 */
import store from '../store/index.js'
import util from '../utils/util'

function createUIID() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}
export default {

    getParameterDic(appDomain) {
        var parameterTemp = {
            parameters: {},
            cmd: {},
            token: store.state.token,
            appDomain: 'shhz',
            appVersion: "mall_h5_1.0.0",
            "clientIdentifierCode": util.getLocalStroageUUID()
        };
        return parameterTemp
    }

}
